export const METRIC_TYPE_OPTIONS = [
  { label: 'GPS',        value: 'gps' },
  { label: 'Testing',    value: 'testing' },
  { label: 'Forceplate', value: 'forceplate' },
  { label: 'Nutrition',  value: 'nutrition' },
  { label: 'Wellness',   value: 'wellness' },
];

// Fallback variable list. At runtime the operand selector is driven by the
// backend-provided list (`misc.user_defined_flag_vars`), which the metric
// backend validates against the same way flags do.
export const VARIABLE_OPTIONS = [
  { label: 'Latest',                        value: 'latest' },
  { label: 'Min',                           value: 'min' },
  { label: 'Max',                           value: 'max' },
  { label: 'Historical Avg',                value: 'hist_avg' },
  { label: 'Historical Standard Deviation', value: 'hist_sd' },
];

// Values are fixed by the metric backend (`_VALID_CURRENT_SCOPES`); only the
// labels are worded to match the flag UI.
export const SCOPE_OPTIONS = [
  { label: 'Current Player',          value: 'current:player' },
  { label: 'Current Player Position', value: 'current:player_position' },
  { label: 'Full Team',               value: 'current:full-team' },
];

export const STAT_OPTIONS = [
  { label: 'Avg',  value: 'avg' },
  { label: 'Best', value: 'best' },
  { label: 'Sum',  value: 'sum' },
];

// The one variable a wellness operand can resolve; shown as "Current date value".
export const CURRENT_DATE_VARIABLE = 'latest';

// value_to_hit_acwr reads only the metric of its operand. The other operand fields keep these values.
export const METRIC_ONLY_SCOPE = 'current:player';
export const METRIC_ONLY_STAT = 'sum';

// Display-label overrides for variable options coming from the backend
export const VARIABLE_LABEL_OVERRIDES: Record<string, string> = {
  latest: 'Current date value',
  min:    'All Time Minimum',
  max:    'All Time Maximum',
};

export interface IUDMOperand {
  metric_identifier: string;
  scope: string;
  variable: string;
  label?: string;
}

export interface IUDMConfig {
  formula: string;
  fetch_params: Record<string, IUDMOperand>;
}

export interface IUserDefinedMetric {
  id?: number;
  name: string;
  metric_type: string;
  config: IUDMConfig;
  unit?: string | null;
  decimal_places?: number | null;
  upper?: number | null;
  lower?: number | null;
  color_strategy?: number | null;
  is_active: boolean;
  is_visible: boolean;
}

export interface IFocusedMetric {
  is_percentage: boolean;
  key: string;
  low_good: boolean;
  metadata: object;
  metric_id: number;
  metric_type: string;
  name: string;
  num_decimals: number;
  unique_identifier: string;
}
